/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @internal
 */
export const PUPPETEER_REVISIONS = Object.freeze({
    chrome: '130.0.6723.58',
    'chrome-headless-shell': '130.0.6723.58',
    firefox: 'stable_131.0.3',
});
//# sourceMappingURL=revisions.js.map